import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DisplayedProduct, ModifierGroupInfo} from "app/models/menu.model";
import {MatDialog} from "@angular/material/dialog";
import {
  ModifierGroupModalComponent, ModifierGroupModalData
} from "app/pages/menu-edit/modifier-group/modifier-group-modal/modifier-group-modal.component";
import {UntilDestroy} from "@ngneat/until-destroy";
import {Organization} from "app/models/organization.model";
import {ModifierGroupApiService} from "app/services/menu-edit/modifier-group-api.service";

@UntilDestroy()
@Component({
  selector: 'app-modifier-group-item',
  templateUrl: './modifier-group-item.component.html',
  styleUrls: ['./modifier-group-item.component.scss']
})
export class ModifierGroupItemComponent {

  @Input() modifierGroup: ModifierGroupInfo;
  @Input() organization: Organization;
  @Input() modifiers: Map<string, DisplayedProduct>;
  @Output() changedChecked: EventEmitter<OnCheckedModifierGroup> = new EventEmitter<OnCheckedModifierGroup>();
  @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deleting: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public dialog: MatDialog,
    private modifierGroupService: ModifierGroupApiService,
  ) { }

  onClickEditModiferGroup(){
    this.dialog.open(ModifierGroupModalComponent, {
      data: {
        modifierGroup: this.modifierGroup,
        modifiers: this.modifiers,
        organization: this.organization,
      } as ModifierGroupModalData
    }).afterClosed().subscribe(res => {
      if(!res){
        return;
      }
      const result = res as ModifierGroupInfo;
      this.modifierGroup = result;
    })
  }

  onClickDelete(event: MouseEvent) {
    event.stopPropagation();
    if (window.confirm('Are you sure you want to delete this modifier group?')) {
      this.loading.emit(true);
      this.modifierGroupService.deleteModifierGroupAsync(this.modifierGroup.id).then(res => {
        this.loading.emit(false);
        if(res){
          alert('success');
          this.deleting.emit(this.modifierGroup.id);
        } else {
          alert('error');
        }
      }).catch(error => {
        this.loading.emit(false);
        alert('error');
      });
    }
  }

  GetModifierName(modifierId: string): string {
    return this.modifiers.get(modifierId)?.name ?? modifierId;
  }

  onCheckedItem($event: any) {
    this.changedChecked.emit({modifierGroupId: this.modifierGroup.id, checked: $event.checked} as OnCheckedModifierGroup);
  }
}

export interface OnCheckedModifierGroup{
  modifierGroupId: string;
  checked: boolean;
}
